export default "__VITE_ASSET__lzat6hgh__"